import React, { useState } from 'react'
import HistoryTextBox from './HistoryTextBox'
import HistoryViewButton from './HistoryViewButton'
import allImgPaths from 'assets/images'
import HistoryFileUpload from './HistoryFileUpload';
import { format } from 'date-fns';
import HistoryContent from './HistoryContent';
import { EMAIL_CATEGORIES, EMAIL_TEMPLATE_CATEGORIES } from 'utils/constant';

interface ContentDraftProps {
    activityIcon?: any;
    data: any;
    period: any
}

const ContentDraft = ({ activityIcon, data, period }: ContentDraftProps) => {
    const handleImageError = (e: any) => {
        e.target.src = allImgPaths.defaultProfile
    }

    const [isView, setIsView] = useState(true)
    const [showMore, setShowMore] = useState(false)

    return (
        <>
            <div className="px-3 pt-3 pb-4 mb-5 last:pb-3 last:mb-0 border-b border-[#F1F1F1] last:border-b-transparent">
                <div className="flex gap-x-4 mb-4">
                    <div className="relative w-10">
                        <img className="min-w-10 h-10 rounded-full" onError={handleImageError} src={data?.user?.profile_image || allImgPaths.defaultProfile} alt="" />
                        <img
                            className="absolute top-7 -right-1 w-5 h-5 rounded-full"
                            src={allImgPaths.historyDraft}
                            alt=""
                        />
                    </div>

                    <div className="leading-none">
                        <div className="font-interMedium text-base text-[#4F4D55] pb-0.5">
                            <span className="font-interMedium text-base text-[#0A090B]">
                                {data?.action_data?.action_user?.name || 'A user'}
                            </span>
                            {
                                data?.action_data?.item == 'isEmailContent' &&
                                <>
                                    {data?.action_data?.fields == 'addTask' ? ' drafted invitations email template' : ' updated invitations email template'}
                                    <span> for task </span>
                                    <span className="font-interMedium text-base text-[#1751D0]"> {data?.task?.title} </span>
                                </>
                            }
                            {
                                data?.action_data?.item == 'isRichTextContent' &&
                                <>
                                    {
                                        data?.action_data?.fields == 'addTask' ? ' drafted an event program content' : ' updated an event program content'
                                    }
                                    <span> for task </span>
                                    <span className="font-interMedium text-base text-[#1751D0]"> {data?.task?.title} </span>
                                </>
                            }
                            {/* {
                                data?.action_data?.item == 'sendAttendeeInvitationEmail' &&
                                <>
                                    <span> sent out invitations to </span>
                                    <span className="font-interMedium text-base text-[#0A090B]"> {data?.action_data?.total} Attendees </span>
                                </>
                            } */}
                            {
                                (data?.action_data?.item == EMAIL_CATEGORIES.ATTENDEE_INVITATION || data?.action_data?.item == EMAIL_CATEGORIES.VENDOR_QUOTE) &&
                                <>
                                    <span> sent out </span>
                                    {
                                        data?.action_data?.templateCategory == EMAIL_TEMPLATE_CATEGORIES.EMAIL_TEMPLATE &&
                                        <span className='font-interMedium text-base'> email invitations </span>
                                    }
                                    {
                                        data?.action_data?.templateCategory == EMAIL_TEMPLATE_CATEGORIES.EVENT_PROGRAM &&
                                        <span className='font-interMedium text-base'> event program </span>
                                    }
                                    {
                                        data?.action_data?.templateCategory == EMAIL_TEMPLATE_CATEGORIES.RFP &&
                                        <span className='font-interMedium text-base'> RFP </span>
                                    }

                                    <span> to </span>
                                    {
                                        data?.action_data?.item == EMAIL_CATEGORIES.ATTENDEE_INVITATION &&
                                        <span className="font-interMedium text-base text-[#0A090B]"> {data?.action_data?.total} Attendees </span>
                                    }
                                    {
                                        data?.action_data?.item == EMAIL_CATEGORIES.VENDOR_QUOTE &&
                                        <span className="font-interMedium text-base text-[#0A090B]"> {data?.action_data?.total} Vendors </span>
                                    }
                                </>
                            }
                            {
                                data?.action_data?.item == 'isRFP' &&
                                <>
                                    {
                                        data?.action_data?.fields == 'addTask' ? ' drafted an RFP content' : ' updated an RFP content'
                                    }
                                    <span> for task </span>
                                    <span className="font-interMedium text-base text-[#1751D0]"> {data?.task?.title} </span>
                                </>
                            }

                        </div>
                        <div className="leading-none flex items-center gap-x-2.5">
                            {
                                (period == 'Today' || period == 'Yesterday') &&
                                <span className="text-xs text-[#7F7D83]">
                                    {format(data?.createdAt, 'hh:mm a')}
                                </span>
                            }
                            {
                                period != 'Today' && period != 'Yesterday' &&
                                <span className="text-xs text-[#7F7D83]">
                                    {format(data?.createdAt, 'EEEE, MMM dd yyyy, hh:mm a')}
                                </span>
                            }
                            <span className="w-1 h-1 bg-[#7F7D83] rounded-full block"></span>
                            <span className="text-xs text-[#7F7D83]">
                                {data?.block?.title} / {data?.card?.title}
                            </span>
                        </div>
                    </div>
                </div>
                {/* {
                    data?.action_data?.item == 'isRichTextContent' &&
                    <HistoryTextBox
                        title={data?.action_data?.title}
                        html={data?.action_data?.new_value}
                        type={'isRichTextContent'}
                        showMore={showMore}
                    />
                } */}
                {
                    data?.action_data?.item == 'isRFP' &&
                    <HistoryTextBox
                        title={data?.action_data?.title}
                        html={data?.action_data?.new_value}
                        type={'isRFP'}
                        showMore={showMore}
                    />
                }
                {
                    data?.action_data?.item == 'isRichTextContent' &&
                    <HistoryTextBox
                        title={data?.action_data?.title}
                        html={data?.action_data?.new_value}
                        type={'isRichTextContent'}
                        showMore={showMore}
                    />
                }
                {
                    data?.action_data?.item == 'isEmailContent' &&
                    <HistoryTextBox
                        title={data?.action_data?.title}
                        html={data?.action_data?.new_value}
                        type={'isEmailContent'}
                        showMore={showMore}
                    />
                }
                {
                    (data?.action_data?.item == EMAIL_CATEGORIES.ATTENDEE_INVITATION || data?.action_data?.item == EMAIL_CATEGORIES.VENDOR_QUOTE) &&
                    <HistoryTextBox
                        title={data?.action_data?.new_value?.title}
                        html={data?.action_data?.new_value?.items}
                        type={data?.action_data?.item}
                        showMore={showMore}
                    />
                }
                <div className="ml-14">
                    {/* <HistoryViewButton /> */}
                    {
                        isView &&
                        <button
                            className="py-1.5 px-3 text-[#fff] text-sm bg-[#1751D0] rounded-md font-interMedium"
                            onClick={() => { setIsView(false); setShowMore(true) }}
                        >
                            View
                        </button>
                    }
                    {
                        !isView &&
                        <button
                            className="py-1.5 px-3 text-[#fff] text-sm bg-[#1751D0] rounded-md font-interMedium"
                            onClick={() => { setIsView(true); setShowMore(false) }}
                        >Hide
                        </button>
                    }
                </div>
            </div>
        </>
    )
}

export default ContentDraft